<template>
  <main :key="key">
    <div v-if="$slots.heading" class="request-header my-3">
      <slot name="heading" />
    </div>
    <b-card
      v-for="request in applications"
      :key="request.id"
      class="mt-1 p-0"
      no-body
      style="border-radius: 8px; background:#FFFFFF;"
    >
      <application
        :isMultiple="request['isMultiple']"
        :isRecommended="isRecommended"
        :request="request"
        v-on="$listeners"
      ></application>
    </b-card>
  </main>
</template>

<script>
  import Application from './Application';

  export default {
    components: {
      Application,
    },
    props: {
      applications: Array,
      isRecommended: { type: Boolean, default: false },
    },
    data() {
      return {
        key: 1,
      };
    },
    watch: {
      applications() {
        this.key++;
      },
    },
  };
</script>

<style scoped>
  .request-header {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }
</style>
